import i18n from 'i18next';

export const TUTORIAL_STRINGS = {
  // INTRODUCTION MODULE
  welcome_message: i18n.t('tutorial.strings.welcome_message'),
  step2_message: i18n.t('tutorial.strings.step2_message'),
  step3_message: i18n.t('tutorial.strings.step3_message'),
  step4_message: i18n.t('tutorial.strings.step4_message'),
  step5_message: i18n.t('tutorial.strings.step5_message'),
  step6_message: i18n.t('tutorial.strings.step6_message'),
  step7_message: i18n.t('tutorial.strings.step7_message'),
  step8_message: i18n.t('tutorial.strings.step8_message'),
  step9_message: i18n.t('tutorial.strings.step9_message'),
  step10_message: i18n.t('tutorial.strings.step10_message'),
  step11_message: i18n.t('tutorial.strings.step11_message'),
  step12_message: i18n.t('tutorial.strings.step12_message'),
  step13_message: i18n.t('tutorial.strings.step13_message'),

  // FUTURE MODULES
  module2_step1: i18n.t('tutorial.strings.module2_step1'),
  module2_step2: i18n.t('tutorial.strings.module2_step2'),
  module2_step3: i18n.t('tutorial.strings.module2_step3'),
  module2_step4: i18n.t('tutorial.strings.module2_step4'),
  module2_step5: i18n.t('tutorial.strings.module2_step5'),
  module2_step6: i18n.t('tutorial.strings.module2_step6'),
  module2_step7: i18n.t('tutorial.strings.module2_step7'),
  module2_step8: i18n.t('tutorial.strings.module2_step8'),
  module2_torso_rotation: i18n.t('tutorial.strings.module2_torso_rotation'),
  module2_step9: i18n.t('tutorial.strings.module2_step9'),
  module2_step10: i18n.t('tutorial.strings.module2_step10'),
  module2_mark_foot: i18n.t('tutorial.strings.module2_mark_foot'),
  module2_mark_location: i18n.t('tutorial.strings.module2_mark_location'),
  module2_mark_location_shortcut: i18n.t('tutorial.strings.module2_mark_location_shortcut'),
  module2_snap_marker: i18n.t('tutorial.strings.module2_snap_marker'),
  module2_clear_markers: i18n.t('tutorial.strings.module2_clear_markers'),
  module2_conclusion: i18n.t('tutorial.strings.module2_conclusion'),
  locations_markers_conclusion: i18n.t('tutorial.strings.locations_markers_conclusion'),

  // POSING MODULE
  posing_intro: i18n.t('tutorial.strings.posing_intro'),
  posing_labels: i18n.t('tutorial.strings.posing_labels'),
  posing_labels_explanation: i18n.t('tutorial.strings.posing_labels_explanation'),
  posing_asymmetry: i18n.t('tutorial.strings.posing_asymmetry'),
  posing_mirror_mode: i18n.t('tutorial.strings.posing_mirror_mode'),
  posing_mirror_flip: i18n.t('tutorial.strings.posing_mirror_flip'),
  posing_reflect: i18n.t('tutorial.strings.posing_reflect'),
  posing_toggle_axes: i18n.t('tutorial.strings.posing_toggle_axes'),
  posing_reset_joint: i18n.t('tutorial.strings.posing_reset_joint'),
  posing_reset_pose: i18n.t('tutorial.strings.posing_reset_pose'),
  posing_conclusion: i18n.t('tutorial.strings.posing_conclusion'),

  // ADVANCED POSING MODULE
  advanced_posing_torso_intro: i18n.t('tutorial.strings.advanced_posing_torso_intro'),
  advanced_posing_torso_t: i18n.t('tutorial.strings.advanced_posing_torso_t'),
  advanced_posing_torso_v: i18n.t('tutorial.strings.advanced_posing_torso_v'),
  advanced_posing_torso_l: i18n.t('tutorial.strings.advanced_posing_torso_l'),
  advanced_posing_drag_relationship_intro: i18n.t('tutorial.strings.advanced_posing_drag_relationship_intro'),
  advanced_posing_drag_select_elbow: i18n.t('tutorial.strings.advanced_posing_drag_select_elbow'),
  advanced_posing_drag_elbow_drag: i18n.t('tutorial.strings.advanced_posing_drag_elbow_drag'),
  advanced_posing_torso_conclusion: i18n.t('tutorial.strings.advanced_posing_torso_conclusion'),

  // DESIGNING SEQUENCES MODULE
  module4_intro: i18n.t('tutorial.strings.module4_intro'),
  module4_change_duration: i18n.t('tutorial.strings.module4_change_duration'),
  module4_change_interval: i18n.t('tutorial.strings.module4_change_interval'),
  module4_zoom: i18n.t('tutorial.strings.module4_zoom'),
  module4_compact: i18n.t('tutorial.strings.module4_compact'),
  module4_expand: i18n.t('tutorial.strings.module4_expand'),
  module4_navigation: i18n.t('tutorial.strings.module4_navigation'),
  module4_add_dot: i18n.t('tutorial.strings.module4_add_dot'),
  module4_move_keyframe: i18n.t('tutorial.strings.module4_move_keyframe'),
  module4_copy_keyframe: i18n.t('tutorial.strings.module4_copy_keyframe'),
  module4_select_multi: i18n.t('tutorial.strings.module4_select_multi'),
  module4_move_multi: i18n.t('tutorial.strings.module4_move_multi'),
  module4_clear_timeline: i18n.t('tutorial.strings.module4_clear_timeline'),
  module4_conclusion: i18n.t('tutorial.strings.module4_conclusion'),
  module4_conclusion_part1: i18n.t('tutorial.strings.module4_conclusion_part1'),
  quick_edit_intro: i18n.t('tutorial.strings.quick_edit_intro'),

  // SEQUENCES WITH SOUND MODULE
  module5_intro: i18n.t('tutorial.strings.module5_intro'),
  module5_load: i18n.t('tutorial.strings.module5_load'),
  module5_options: i18n.t('tutorial.strings.module5_options'),
  module5_waveform: i18n.t('tutorial.strings.module5_waveform'),
  module5_grid: i18n.t('tutorial.strings.module5_grid'),
  module5_dot: i18n.t('tutorial.strings.module5_dot'),
  module5_subdivision: i18n.t('tutorial.strings.module5_subdivision'),
  module5_subdivision_effect: i18n.t('tutorial.strings.module5_subdivision_effect'),
  module5_conclusion: i18n.t('tutorial.strings.module5_conclusion'),

  // LIBRARY MANAGEMENT MODULE
  module6_intro: i18n.t('tutorial.strings.module6_intro'),
  module6_switch_tab: i18n.t('tutorial.strings.module6_switch_tab'),
  module6_load_pose: i18n.t('tutorial.strings.module6_load_pose'),
  module6_create_folder: i18n.t('tutorial.strings.module6_create_folder'),
  module6_switch_sequences: i18n.t('tutorial.strings.module6_switch_sequences'),
  module6_drag_drop: i18n.t('tutorial.strings.module6_drag_drop'),
  module6_advanced_ops: i18n.t('tutorial.strings.module6_advanced_ops'),
  module6_conclusion: i18n.t('tutorial.strings.module6_conclusion'),

  // MENUS & SHORTCUTS MODULE
  shortcuts_intro: i18n.t('tutorial.strings.shortcuts_intro'),
  shortcuts_stage: i18n.t('tutorial.strings.shortcuts_stage'),
  shortcuts_joint: i18n.t('tutorial.strings.shortcuts_joint'),
  shortcuts_timeline: i18n.t('tutorial.strings.shortcuts_timeline'),
  shortcuts_switch_poses: i18n.t('tutorial.strings.shortcuts_switch_poses'),
  shortcuts_folders: i18n.t('tutorial.strings.shortcuts_folders'),
  shortcuts_library: i18n.t('tutorial.strings.shortcuts_library'),
  shortcuts_conclusion: i18n.t('tutorial.strings.shortcuts_conclusion'),

  // WORKSPACE MASTERY MODULE
  wm_intro: i18n.t('tutorial.strings.wm_intro'),
  wm_undo_redo: i18n.t('tutorial.strings.wm_undo_redo'),
  wm_random_pose: i18n.t('tutorial.strings.wm_random_pose'),
  wm_randomness: i18n.t('tutorial.strings.wm_randomness'),
  wm_auto_save: i18n.t('tutorial.strings.wm_auto_save'),
  wm_confirm_reset: i18n.t('tutorial.strings.wm_confirm_reset'),
  wm_scroll_rotation: i18n.t('tutorial.strings.wm_scroll_rotation'),
  wm_new_sequence: i18n.t('tutorial.strings.wm_new_sequence'),
  wm_import_export: i18n.t('tutorial.strings.wm_import_export'),
  wm_conclusion: i18n.t('tutorial.strings.wm_conclusion'),

  // NOTES AND ANNOTATIONS
  notes_intro: i18n.t('tutorial.strings.notes_intro'),
  notes_write_pose_note: i18n.t('tutorial.strings.notes_write_pose_note'),
  notes_save_pose_note: i18n.t('tutorial.strings.notes_save_pose_note'),
  notes_create_frame_note: i18n.t('tutorial.strings.notes_create_frame_note'),
  notes_write_frame_note: i18n.t('tutorial.strings.notes_write_frame_note'),
  notes_hover_tooltip: i18n.t('tutorial.strings.notes_hover_tooltip'),
  notes_edit_tooltip: i18n.t('tutorial.strings.notes_edit_tooltip'),
  notes_conclusion: i18n.t('tutorial.strings.notes_conclusion')
};

export const TUTORIAL_METADATA = {
  introduction: {
    title: i18n.t('tutorial.metadata.introduction.title'),
    description: i18n.t('tutorial.metadata.introduction.description')
  },
  attitudes: {
    title: i18n.t('tutorial.metadata.attitudes.title'),
    description: i18n.t('tutorial.metadata.attitudes.description')
  },
  locations_markers: {
    title: i18n.t('tutorial.metadata.locations_markers.title'),
    description: i18n.t('tutorial.metadata.locations_markers.description')
  },
  posing: {
    title: i18n.t('tutorial.metadata.posing.title'),
    description: i18n.t('tutorial.metadata.posing.description')
  },
  advanced_posing: {
    title: i18n.t('tutorial.metadata.advanced_posing.title'),
    description: i18n.t('tutorial.metadata.advanced_posing.description')
  },
  designing_sequences_no_music: {
    title: i18n.t('tutorial.metadata.designing_sequences_no_music.title'),
    description: i18n.t('tutorial.metadata.designing_sequences_no_music.description')
  },
  quick_editing_timeline: {
    title: i18n.t('tutorial.metadata.quick_editing_timeline.title'),
    description: i18n.t('tutorial.metadata.quick_editing_timeline.description')
  },
  designing_sequences_with_music: {
    title: i18n.t('tutorial.metadata.designing_sequences_with_music.title'),
    description: i18n.t('tutorial.metadata.designing_sequences_with_music.description')
  },
  notes_annotations: {
    title: i18n.t('tutorial.metadata.notes_annotations.title'),
    description: i18n.t('tutorial.metadata.notes_annotations.description')
  },
  library_management: {
    title: i18n.t('tutorial.metadata.library_management.title'),
    description: i18n.t('tutorial.metadata.library_management.description')
  },
  context_shortcuts: {
    title: i18n.t('tutorial.metadata.context_shortcuts.title'),
    description: i18n.t('tutorial.metadata.context_shortcuts.description')
  },
  workspace_mastery: {
    title: i18n.t('tutorial.metadata.workspace_mastery.title'),
    description: i18n.t('tutorial.metadata.workspace_mastery.description')
  },
  using_choreoverse: {
    title: i18n.t('tutorial.metadata.using_choreoverse.title'),
    description: i18n.t('tutorial.metadata.using_choreoverse.description')
  },
  designing_poses_ai: {
    title: i18n.t('tutorial.metadata.designing_poses_ai.title'),
    description: i18n.t('tutorial.metadata.designing_poses_ai.description')
  },
  designing_sequences_ai: {
    title: i18n.t('tutorial.metadata.designing_sequences_ai.title'),
    description: i18n.t('tutorial.metadata.designing_sequences_ai.description')
  },
  sharing_collaborating: {
    title: i18n.t('tutorial.metadata.sharing_collaborating.title'),
    description: i18n.t('tutorial.metadata.sharing_collaborating.description')
  },
  showcasing_monetization: {
    title: i18n.t('tutorial.metadata.showcasing_monetization.title'),
    description: i18n.t('tutorial.metadata.showcasing_monetization.description')
  }
};
